var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.997,
    height: 20,
    viewBox: "0 0 19.997 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M208.787,0H215.5a1.5,1.5,0,0,1,.873.539,5.475,5.475,0,0,1,.338.71v9.178a.122.122,0,0,0-.021.032,1.477,1.477,0,0,1-1.608,1.207q-2.968,0-5.935,0a2.079,2.079,0,0,1-.5-.052,1.454,1.454,0,0,1-1.1-1.492q0-2.763,0-5.525c0-1.022,0-2.044,0-3.065A1.466,1.466,0,0,1,208.494.1C208.589.059,208.689.032,208.787,0Z",
    transform: "translate(-196.721)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M7.926,0a4.38,4.38,0,0,1,.737.375,1.34,1.34,0,0,1,.5,1.118c0,1.23.009,2.461,0,3.69A1.445,1.445,0,0,1,7.676,6.665q-3.095.014-6.19,0A1.452,1.452,0,0,1,0,5.146q0-1.8,0-3.593A1.454,1.454,0,0,1,1.162.031.182.182,0,0,0,1.209,0H7.926Z",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M216.559,260.844c-.035.11-.063.224-.108.33a1.376,1.376,0,0,1-1.312.913c-2.108.015-4.217.012-6.326,0a1.427,1.427,0,0,1-1.415-1.429c-.02-1.269-.022-2.538,0-3.807a1.44,1.44,0,0,1,1.518-1.428c1.471,0,2.942,0,4.412,0,.553,0,1.106,0,1.66,0a1.463,1.463,0,0,1,1.542,1.189.228.228,0,0,0,.028.051Z",
    transform: "translate(-196.565 -242.097)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M0,165.454V161.18a1.466,1.466,0,0,1,1.562-1.565q3.026,0,6.051,0a1.466,1.466,0,0,1,1.554,1.555q0,4.275,0,8.549A1.466,1.466,0,0,1,7.6,171.282q-3.026,0-6.051,0A1.461,1.461,0,0,1,0,169.729q0-2.137,0-4.275Z",
    transform: "translate(-0.004 -151.286)",
    fill: "#9c8eeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.0f7e81291d013a3f0c90076c4c30a94c.svg";
export { ForwardRef as ReactComponent };